export const reportListingTypes = {
  posicaoCarga: "posicao-carga",
  autosservicos: "autosservicos",
  creditoClientes: "credito-clientes",
  erroPesquisa: "erro-pesquisa",
};
